"use strict";

var uniq = require('lodash/uniq');

var flattenDeep = require('lodash/flattenDeep');
/**
     * gathers all the nested values of an Object recursively.s
     * @param {Object} object
     */


function gatherValues(object) {
  return uniq(flattenDeep(Object.keys(object).map(function (key) {
    var val = object[key];

    if (Object.prototype.toString.call(val) === '[object String]') {
      return val;
    }

    return gatherValues(val);
  })));
}

module.exports = gatherValues;